<template>
    <!-- 
    1.화면ID    : MSM_SA_001
    2.화면명    : 영업기회 알람 등록
    3.작성자    : 윤태영 차장
      수정자    : 
    4.화면설명  : 영업관리 알람등록 화면이다. (배치화면처리 된다 )
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    -->
  
  
    <div class="content-wrap">
  
      <!-- 영업기회ID -->
      <div class="alarm-headline-wrap">
        <div class="alarm-headline">
          <ElLabel name="영업기회ID">
            <template #end="{id}">
              <div class="input-group">
                <ElInput :id="id" ref="salesIdRef" v-model="state.alarmParams.sales_id" readonly/>
              </div>
            </template>
  
          </ElLabel>
        </div>
      </div>
  
      <div class="alarm-card mt-3">
        <div class="alarm-card-head">Warranty 알람설정</div>
        <div class="row g-0 alarm-card-body">
  
          <div class="col-sm-12 col-lg-6 border-end">
            <div class="alarm-card-stitle">되풀이 방법</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <!--되풀이 방법 radio 영역-->
              <div class="alarm-week">
                <div class="form-check py-2" v-for="(item,index) of iterationRadio" :key="index">
                  <ElLabel :name="item.cdNm">
                    <template #start="{id}">
                      <ElRadio
                        v-model="state.alarmParams.w_alarm_prd"
                        :id="id"
                        :value="item.cd"
                        @radioChange="iterationChng('w')"
                        disabled
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
  
              <div v-if="state.alarmParams.w_alarm_prd === 'D'">
                <div class="p-3">
                </div>
              </div>
  
              <div v-if="state.alarmParams.w_alarm_prd === 'W'">
                <div class="p-3">
                  <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          :id="id"
                          :value="day.cd"
                          v-model="state.alarmParams.w_alarm_week"
                          disabled
                        />
                      </template>
                    </ElLabel>
                  </div>
                </div>
              </div>
  
              <div v-if="state.alarmParams.w_alarm_prd === 'M'">
                <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput 
                    :id="id" 
                    v-model="state.alarmParams.w_alarm_cyc" 
                    classNm="form-control form-control-sm w-25 m-1" 
                    :onlyNumber="true"
                    readonly
                    />
                    주마다 다음 요일에 되풀이
                  </div>
                  <div>
  
                    <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                      <ElLabel :name="day.cdNm">
                        <template #start="{id}">
                          <ElCheckbox
                            v-model="state.alarmParams.w_alarm_week"
                            :id="id"
                            :value="day.cd"
                            disabled
                          />
                        </template>
                      </ElLabel>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div v-if="state.alarmParams.w_alarm_prd === 'Y'">
                <div class="p-3">
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd"
                    :select-date="state.alarmParams.w_alarm_year" disabled/>
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-sm-12 col-lg-6">
            <div class="alarm-card-stitle">되풀이 범위</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <div class="alarm-week">
                <div class="mb-3">
                  <ElLabel name="시작">
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        :select-date="state.alarmParams.w_start_dt" 
                        disabled
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
  
              <div class="p-3">
                <div class="form-check py-2">
                  <ElLabel name="종료 날짜">
                    <template #start="{id}">
                      <ElRadio
                        ref="endDate"
                        v-model="state.alarmParams.w_end_ck"
                        :id="id"
                        value="1"
                        disabled
                      />
                    </template>
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        @return="r => state.alarmParams.w_end_dt = r"
                        :select-date="state.alarmParams.w_end_dt" 
                        disabled
                      />
                    </template>
                  </ElLabel>
  
                  
                
  
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="다음 되풀이 후 종료됨" classNm="form-check-label">
                    <template #start="{id}">
                      <ElRadio
                        ref="reEnd"
                        v-model="state.alarmParams.w_end_ck"
                        :id="id"
                        value="2"
                        disabled
                      />
                      
                      
                    </template>
                    <template #end>
                      <div class="d-flex">
                        <ElInput :id="id" v-model="state.alarmParams.w_end_cnt" :disabled="state.alarmParams.w_end_ck !== '2'" readonly/>
                        <span id="" class="form-text">
                          회
                        </span>
                      </div>
                    </template>
                  </ElLabel>
  
                  
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="종료 날짜 지정하지 않음">
                    <template #start="{id}">
                      <ElRadio
                        ref="noReEnd"
                        v-model="state.alarmParams.w_end_ck"
                        :id="id"
                        value="3"
                        disabled
                      />
                    </template>
                  </ElLabel>
  
  
                </div>
              </div>
  
            </div>
          </div>
        </div>
        <div class="alarm-card-foot">
          <div>
            <div class="form-check form-switch">
  
              <ElLabel name="Warranty 알람기능 활성">
                <template #start="{id}">
                  <ElCheckbox
                    v-model="state.alarmParams.w_enable_yn"
                    :id="id"
                    disabled
                  />
                </template>
              </ElLabel>
  
              
            </div>
          </div>
        </div>
      </div>
  
      <div class="alarm-card mt-3">
        <div class="alarm-card-head">지급일 알람설정</div>
        <div class="row g-0 alarm-card-body">
  
          <div class="col-sm-12 col-lg-6 border-end">
            <div class="alarm-card-stitle">되풀이 방법</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <div class="alarm-week">
                <div class="form-check py-2" v-for="(item,index) of iterationRadio" :key="index">
                  <ElLabel :name="item.cdNm">
                    <template #start="{id}">
                      <ElRadio
                        v-model="state.alarmParams.p_alarm_prd"
                        :id="id"
                        :value="item.cd"
                        disabled
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
  
              <div v-if="state.alarmParams.p_alarm_prd === 'D'">
                <div class="p-3">
                </div>
              </div>
  
              <div v-if="state.alarmParams.p_alarm_prd === 'W'">
                <div class="p-3">
                  <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.p_alarm_week"
                          :id="id"
                          :value="day.cd"
                          disabled
                        />
                      </template>
                    </ElLabel>
                  </div>
                </div>
              </div>
  
              <div v-if="state.alarmParams.p_alarm_prd === 'M'">
                <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput :id="id" v-model="state.alarmParams.p_alarm_cyc" classNm="form-control form-control-sm w-25 m-1" readonly/>
                    주마다 다음 요일에 되풀이
                  </div>
                  <div>
  
                    <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                      <ElLabel :name="day.cdNm">
                        <template #start="{id}">
                          <ElCheckbox
                            v-model="state.alarmParams.p_alarm_week"
                            :id="id"
                            :value="day.cd"
                            disabled
                          />
                        </template>
                      </ElLabel>
                    </div>
  
                  </div>
                </div>
              </div>
              <div v-if="state.alarmParams.p_alarm_prd === 'Y'">
                <div class="p-3">
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.alarmParams.p_alarm_year = r"
                    :select-date="state.alarmParams.p_alarm_year" disabled/>
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-sm-12 col-lg-6">
            <div class="alarm-card-stitle">되풀이 범위</div>
            <div class="d-flex align-items-stretch" style="height:14rem;">
  
              <div class="alarm-week">
                <div class="mb-3">
                  <ElLabel name="시작">
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        :selectDate="state.alarmParams.p_start_dt" 
                        disabled
                      />
                    </template>
                  </ElLabel>
                  
                </div>
              </div>
              <div class="p-3">
                <div class="form-check py-2 pe-2">
                  <ElLabel name="종료 날짜">
                    <template #start="{id}">
                      <ElRadio
                        ref="endDate"
                        v-model="state.alarmParams.p_end_ck"
                        value="1"
                        disabled
                      />
                    </template>
                    <template #end="{id}">
                      <DatePicker 
                        :id="id"
                        :frmType="'YMD'" 
                        format="yyyy-MM-dd" 
                        :selectDate="state.alarmParams.p_end_dt"
                        disabled
                      />
                    </template>
                  </ElLabel>
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="다음 되풀이 후 종료됨">
                    <template #start="{id}">
                      <ElRadio
                        ref="reEnd"
                        v-model="state.alarmParams.p_end_ck"
                        value="2"
                        disabled
                      />
                    </template>
                    <template #end="{id}">
                      <div class="d-flex">
                        <ElInput :id="id" v-model="state.alarmParams.p_end_cnt" type="number" :disabled="state.alarmParams.p_end_ck !== '2'" readonly/>
                        <span class="form-text">
                          회
                        </span>
                      </div>
                    </template>
                  </ElLabel>
  
                </div>
                <div class="form-check py-2">
  
                  <ElLabel name="종료 날짜 지정하지 않음">
                    <template #start="{id}">
                      <ElRadio
                        :id="id"
                        ref="reEnd"
                        v-model="state.alarmParams.p_end_ck"
                        value="3"
                        disabled
                      />
                    </template>
                  </ElLabel>
  
  
                </div>
              </div>
  
            </div>
          </div>
        </div>
        <div class="alarm-card-foot">
          <div>
            <div class="form-check form-switch">
              <ElLabel name="지급일 알람설정 활성화">
                  <template #start="{id}">
                    <ElCheckbox
                      :id="id"
                      ref="reEnd"
                      v-model="state.alarmParams.p_enable_yn"
                      disabled
                    />
                  </template>
                </ElLabel>
  
            </div>
          </div>
        </div>
      </div>
  
  
    </div>
  
  </template>
  
<script setup>

import { reactive, onMounted, onBeforeMount, ref, computed } from 'vue';
import routerCmn from '@/js/vueRouterCmn';
import { useRouter } from "vue-router";
import DatePicker from '@/components/common/DatePicker.vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { alarmSelect } from '@/api/alarm';

const salesIdRef = ref();
const router = useRouter();

// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date()
var dtStr = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + dt.getDate();

onMounted(() => {
  // state.alarmParams.w_end_dt = dtStr;
  // state.alarmParams.p_end_dt = dtStr;
})

onBeforeMount(async () => {
  const sparam  = history.state.alarm_seq;
  //state.alarmParams.sales_id = sparam;
  state.alarmParams.alarm_seq = sparam;
  if (state.alarmParams.alarm_seq) {

    let param = {
      sales_id: state.alarmParams.sales_id,
      alarm_seq: state.alarmParams.alarm_seq
    }
    try {
      setIsLoading(true)
      const res = await alarmSelect(param)
      if(res){
        state.pageType = 'update'
        let detailCp = res.rtn
        if(Object.keys(detailCp).length <= 0){
          alert("조회 데이터가 없습니다. 확인해주세요 ")
          routerCmn.routerPush('/sm/MSM_SA_002')
          return
        }
        state.alarmParams.alarm_seq = detailCp.alarm_seq
        state.alarmParams.sales_id = detailCp.sales_id
        state.alarmParams.w_alarm_cyc = detailCp.w_alarm_cyc
        state.alarmParams.w_alarm_prd = detailCp.w_alarm_prd
        if(detailCp.w_alarm_week){
          let alarmWeek = [...detailCp.w_alarm_week.replaceAll('0','')]

          for (let item of alarmWeek) {
            state.alarmParams.w_alarm_week.push(item)
          }
        }

        state.alarmParams.w_enable_yn = detailCp.w_enable_yn === 'Y';
        state.alarmParams.p_enable_yn = detailCp.p_enable_yn === 'Y';


        state.alarmParams.w_start_dt = detailCp.fmt_w_start_dt || null
        state.alarmParams.w_end_dt = detailCp.fmt_w_end_dt || null
        state.alarmParams.w_snd_cnt = detailCp.w_snd_cnt || 0
        state.alarmParams.w_snd_dt = detailCp.fmt_w_snd_dt || null
        state.alarmParams.w_alarm_year = detailCp.fmt_w_alarm_year || null
        state.alarmParams.w_end_ck = detailCp.w_end_ck

        state.alarmParams.p_alarm_cyc = detailCp.p_alarm_cyc
        state.alarmParams.p_alarm_prd = detailCp.p_alarm_prd

        if(detailCp.p_alarm_week){
          let alarmWeek = [...detailCp.p_alarm_week.replaceAll('0','')]

          for (let item of alarmWeek) {
            state.alarmParams.p_alarm_week.push(item)
          }
        }

        state.alarmParams.p_start_dt = detailCp.fmt_p_start_dt || null
        state.alarmParams.p_end_dt = detailCp.fmt_p_end_dt || null
        state.alarmParams.p_end_cnt = detailCp.p_end_cnt || 0
        state.alarmParams.p_snd_cnt = detailCp.p_snd_cnt || 0
        state.alarmParams.p_snd_dt = detailCp.fmt_p_snd_dt || null
        state.alarmParams.p_alarm_year = detailCp.fmt_p_alarm_year || null
        state.alarmParams.p_end_ck = detailCp.p_end_ck

        state.dupCheck = true

        Object.keys(state.alarmParams).forEach((key)=>{
          if(key.includes('_dt')){
            state.alarmParams[key] = state.alarmParams[key] === '1900-01-01' ? null : state.alarmParams[key]
          }
        })
      }
      

    } catch (err) {
      console.log('영업기회 알람 등록 api 에러', err)
      routerCmn.routerPush('/sm/MSM_SA_002')
    } finally {
      setIsLoading(false)
    }
  }else{
    alert('잘못된 접근입니다.')
    router.back()
  }
})


const iterationRadio = ref([
  {cd : 'D', cdNm : '매일'},
  {cd : 'W', cdNm : '매주'},
  {cd : 'M', cdNm : '매월'},
])

const dailyCheck = [
  {cd : 'A', cdNm : '월요일'},
  {cd : 'B', cdNm : '화요일'},
  {cd : 'C', cdNm : '수요일'},
  {cd : 'D', cdNm : '목요일'},
  {cd : 'E', cdNm : '금요일'},
]

const state = reactive({
  AAA : 'AW',
  BBB : 'AP',
  alarmParams: {
    alarm_seq: '',
    sales_id: '',
    w_alarm_cyc: '',
    w_alarm_prd: 'D',
    w_alarm_week: [],
    w_alarm_year: '',
    w_enable_yn: true,
    w_start_dt: '',
    w_end_dt: '',
    w_end_cnt: 0,
    w_snd_cnt: 0,
    w_snd_dt: null,
    w_end_ck: '1',
    p_alarm_cyc: 0,
    p_alarm_prd: 'D',
    p_alarm_week: [],
    p_alarm_year: '',
    p_enable_yn: true,
    p_start_dt: '',
    p_end_dt: '',
    p_end_cnt: 0,
    p_snd_cnt: 0,
    p_snd_dt: null,
    p_end_ck: '1',
    upd_id: ''
  },

});
</script>